export default function parseCustomVarAttributes(customVar) {
  if (!customVar) {
    return {};
  }

  const attributes = {};
  const regex = /([^\s=]+)=("[^"]*"|'[^']*')/g;
  let match = regex.exec(customVar);
  while (match) {
    const key = match[1];
    const value = match[2].slice(1, -1);
    if (value) {
      attributes[key] = value;
    }
    match = regex.exec(customVar);
  }
  return attributes;
}
